module.exports = __webpack_public_path__ + "img/note-gray.eb49c7a0.png";